import axios from 'axios';
import config from '../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../core/modules/common/tools/URLTools';

const apiFetchResditByReceivingPostNumbered = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getResditByReceivingPostNumbered',
    stub: config.useStubbedEndpoints,
  });

  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchResditByReceivingPostNumbered;
